import { atom } from 'jotai';

export const ready = atom(false);
